import { RotatingLines } from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import Constants from "../../../Constants";
import SuccessMessage from "../../../components/SuccessMessage";
import jQuery from "jquery";
import Select from 'react-select';
import { isValidHttpUrl } from "../../../services/Util";

export default function PardotCredential(props) {

  const businessUnitIdRef = useRef(null);
  const identityUrlRef = useRef(null);
  const endpointUrlRef = useRef(null);
  const clientIdRef = useRef(null);
  const clientSecretRef = useRef(null);

  const identityUrls = [
    {value:'https://login.salesforce.com',label:'Production'},
    {value:'https://test.salesforce.com',label:'Sandbox'}
  ]
  const endpointUrls = [
    {value:'https://pi.pardot.com',label:'Production'},
    {value:'https://pi.demo.pardot.com',label:'Sandbox'}
  ]


  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [businessUnitId, setBusinessUnitId] = useState(businessUnitIdRef.current?.value);
  const [clientId, setClientId] = useState(clientIdRef.current?.value);
  const [clientSecret, setClientSecret] = useState(clientSecretRef.current?.value);
  const [identityUrl, setIdentityUrl] = useState();
  const [endpointUrl, setEndpointUrl] = useState();
  const [endpointUrlEnv, setEndpointUrlEnv] = useState();
  const [identityUrlEnv, setIdentityUrlEnv] = useState();

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
        //props.closePopup();
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
      let eUrls = endpointUrls.filter(url => url.value === credentialData?.credentials?.ENDPOINT_URL);
      setEndpointUrlEnv(eUrls?.length > 0 ? eUrls[0].label : endpointUrls[0].label)
      setEndpointUrl(credentialData?.credentials?.ENDPOINT_URL != null ? credentialData?.credentials?.ENDPOINT_URL : endpointUrls[0].value)
      jQuery("#pardot-endpoint-url-input").val(credentialData?.credentials?.ENDPOINT_URL != null ? credentialData?.credentials?.ENDPOINT_URL : endpointUrls[0].value);
    
      let iUrls = identityUrls.filter(url => url.value === credentialData?.credentials?.IDENTITY_URL);
      setIdentityUrlEnv(iUrls?.length > 0 ? iUrls[0].label : identityUrls[0].label)
      setIdentityUrl(credentialData?.credentials?.IDENTITY_URL != null ? credentialData?.credentials?.IDENTITY_URL : identityUrls[0].value)
      jQuery("#pardot-identity-url-input").val(credentialData?.credentials?.IDENTITY_URL != null ? credentialData?.credentials?.IDENTITY_URL : identityUrls[0].value);

      jQuery("#pardot-client-id-input").val(credentialData?.credentials?.CLIENT_ID)
      jQuery("#pardot-client-secret-input").val(credentialData?.credentials?.CLIENT_SECRET)
      jQuery("#pardot-auth-code-input").val(credentialData?.credentials?.DEVICE_AUTH_CODE)

  }, [])

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateEloquaCredButton = jQuery("#validate-credential");
    if (businessUnitId?.length > 0 && clientId?.length > 0 && clientSecret?.length > 0 && 
      identityUrl?.length > 0 && isValidHttpUrl(identityUrl) && endpointUrl?.length> 0 && isValidHttpUrl(endpointUrl)) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateEloquaCredButton?.attr("disabled", "true")
    }
  }, [businessUnitId, clientId, clientSecret, identityUrl, endpointUrl]);

  const onChnageInputFields = () => {
    setBusinessUnitId(businessUnitIdRef.current?.value);
    setClientId(clientIdRef.current?.value);
    setClientSecret(clientSecretRef.current?.value);
    setIdentityUrl(identityUrlRef.current?.value);
    setEndpointUrl(endpointUrlRef.current?.value);
  }

  const identityUrlEnvChanged = (e) => {
    setIdentityUrlEnv(e.label);
    setIdentityUrl(e.value);
    jQuery("#pardot-identity-url-input").val(e.value);
  }
  const endpointUrlEnvChanged = (e) => {
    setEndpointUrlEnv(e.label)
    setEndpointUrl(e.value)
    jQuery("#pardot-endpoint-url-input").val(e.value);
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
    </div> 
    {errorMessages?.length > 0 &&
      <><ul id="brightcoveServerError" className="list-error">
      {errorMessages?.map(error => {
        return (<li>{JSON.stringify(error)}</li>) 
      })}
      </ul><br/></>
    }
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}

     <div className="global-dropdown-block flex" style={{ 'align-items': 'end' }}>
      <div className="mr-15">
        <label>Identity Url (Salesforce Account)</label>
        <Select className="global-dropdown-select" 
          menuShouldScrollIntoView={false}
          closeMenuOnSelect={true}
          classNamePrefix='cw'
          defaultValue={identityUrls[0]} 
          aria-label="Select Identity Url Environment"
          options={identityUrls}
          value={identityUrls.filter(function (option) {
              return option.label === identityUrlEnv;
          })}
          onChange={e => identityUrlEnvChanged(e)}
        />
        </div>
        <div className="global-dropdown-select">
          <input id="pardot-identity-url-input" type="text" className="form-control-sm" placeholder="Identity Url" defaultValue={credentialData?.credentials?.IDENTITY_URL} 
          ref={identityUrlRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block flex" style={{ 'align-items': 'end' }}>
        <div className="mr-15">
        <label>Endpoint Url (Pardot Account)</label>
        <Select className="global-dropdown-select" 
            menuShouldScrollIntoView={false}
            closeMenuOnSelect={true}
            classNamePrefix='cw'
            defaultValue={endpointUrls[0]} 
            aria-label="Select Endpoint Url Environment Type"
            options={endpointUrls}
            value={endpointUrls.filter(function (option) {
                return option.label === endpointUrlEnv;
            })}
            onChange={e => endpointUrlEnvChanged(e)}
          />
        </div>
        <div className="global-dropdown-select">
          <input id="pardot-endpoint-url-input" type="text" className="form-control-sm" placeholder="Endpoint Url" defaultValue={credentialData?.credentials?.ENDPOINT_URL}
          ref={endpointUrlRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Client ID</label>
        <div className="global-dropdown-select">
          <input id="pardot-client-id-input" type="text" className="form-control-sm" placeholder="Client Id" defaultValue={credentialData?.credentials?.CLIENT_ID} 
          ref={clientIdRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Client Secret</label>
        <div className="global-dropdown-select">
          <input id="pardot-client-secret-input" type="text" className="form-control-sm" placeholder="Client Secret" defaultValue={credentialData?.credentials?.CLIENT_SECRET} 
          ref={clientSecretRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Business Unit ID</label>
        <div className="global-dropdown-select">
          <input id="pardot-business-unit-id-input" type="text" className="form-control-sm" placeholder="Business Unit ID" defaultValue={credentialData?.credentials?.BUSINESS_UNIT_ID} 
          ref={businessUnitIdRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <input id="pardot-auth-code-input" type="hidden" className="form-control-sm" placeholder="Auth Code" defaultValue={credentialData?.credentials?.DEVICE_AUTH_CODE} />   
      
    </>
  )
}


